export const fetchMembers = (filters = '') => ({
    method: 'GET',
    url: `/collaboration/members/all${filters}`,
});

export const fetchGroups = (filters = '') => ({
    method: 'GET',
    url: `/collaboration/members/all${filters}`,
});

export const getFilters = () => ({
    method: 'GET',
    url: '/dreports2/filters'
})

export const getEthereumBalance = () => ({
    method: 'POST',
    url: '/user/getbalance'
})

export const getWallets = () => ({
    method: 'POST',
    url: '/user/wallets'
})

export const getParticipantBalance = (userId) => ({
    method: 'POST',
    url: `/user/wallet/balance/${userId}`
})

export const getBlockchainTransactions = () => ({
    method: 'POST',
    url: '/user/gettransactions'
})

export const createwallet = () => ({
    method: 'POST',
    url: '/user/createwallet'
})

export const transferEth = (data) => ({
    method: 'POST',
    url: '/user/transferether',
    data
})

export const changePassword = (data) => ({
    method: 'POST',
    url: '/user/changepassword',
    data
})

export const disableTwoFactor = () => ({
    method: 'POST',
    url: '/user/disabletwofactor'
})

export const generateTwoFactor = () => ({
    method: 'POST',
    url: '/twofactor/generate'
})

export const registerTwoFactor = (data) => ({
    method: 'POST',
    url: '/twofactor/register',
    data
})

export const saveSignature = (data) => ({
    method: 'POST',
    url: '/user/recordsignature',
    data
})

export const sendToPhone = (data) => ({
    method: 'POST',
    url: '/user/signaturetophone',
    data
})

export const fetchProcesses = () => ({
    method: 'GET',
    url: '/processes'
})